/*
  COMPONENT: Media Controller

  Owns:
  - Autoplay video safety
  - Pause off-screen videos

  Does not own:
  - Image rendering markup
  - Product media gallery navigation
*/

(() => {
  const trackedVideos = new Set();

  function syncVideo(video, shouldPlay) {
    if (shouldPlay && video.paused) {
      video.play().catch(() => {});
    }

    if (!shouldPlay && !video.paused) {
      video.pause();
    }
  }

  function initializeMedia(root = document) {
    const videos = root.querySelectorAll('.responsive-media video, .theme-block-video__media[autoplay]');
    if (!videos.length) return;

    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      trackedVideos.add(video);
      window.CurtisTheme?.registerCleanup?.(video, () => trackedVideos.delete(video));
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          syncVideo(entry.target, entry.isIntersecting);
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => {
      observer.observe(video);
      window.CurtisTheme?.registerCleanup?.(video, () => observer.unobserve(video));
    });
  }

  window.CurtisMedia = {
    initialize: initializeMedia,
  };

  initializeMedia();
  document.addEventListener('shopify:section:load', (event) => initializeMedia(event.target));
})();
